import { render, staticRenderFns } from "./CDropdown.vue?vue&type=template&id=ccc97866&scoped=true&"
import script from "./CDropdown.vue?vue&type=script&lang=js&"
export * from "./CDropdown.vue?vue&type=script&lang=js&"
import style0 from "./CDropdown.vue?vue&type=style&index=0&id=ccc97866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc97866",
  null
  
)

export default component.exports